import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types'; // or PropTypes = require('prop-types');
import StorageService from '../../services/Storage';
import AuthService from '../../services/AuthService';
import ComponetWithHeader from '../CompentWithHeader/ComponetWithHeader';
import ComponentWithoutHeader from '../ComponentWithoutHeader/ComponentWithoutHeader';
import ComponentWithoutSideNav from '../ComponentWithoutSideNav/ComponentWithoutSideNav';
import { Roles } from '../../constants/constant.role';


/**
 * private route component to prevent unauthorize access
 */
const OnBoardingRoute = ({ component: Component, sidenav, header, ...rest }) => {
  // uncomment  when authentication api implement

  const isAuthenticated = AuthService.isAuthenticated();
  return (

    <Route
      {...rest}
      render={props => {
        if (isAuthenticated === true) {
          let userDetail = StorageService.getUserDetail();
          if (userDetail.type === Roles.FLEET_MANAGER_ROLE || userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE || userDetail.is_login_first_time === false) {
            return <Redirect to={{
              pathname: '/',
            }}
            />
          }
          // if (userDetail.is_login_first_time === false) {
          //   return <Redirect to={{
          //     pathname: '/',
          //   }}
          //   />
          // }
          if (header === true && sidenav === true) {
            return <ComponetWithHeader component={Component} {...props} />
          } else if (header === true && sidenav === false) {
            return <ComponentWithoutSideNav component={Component} {...props} />
          } else {
            return <ComponentWithoutHeader component={Component} {...props} />
          }
        } else {
          return <Redirect to={{
            pathname: '/login',
          }}
          />
        }
      }
      }
    />
  );
};

OnBoardingRoute.propTypes = {
  component: PropTypes.any.isRequired,
};

export default OnBoardingRoute;
